import * as React from "react";
import ModelContainer from "../../../components/model/ModelContainer";
import PageTitle from "../../../components/model/PageTitle";
import ModelTitle from "../../../components/model/ModelTitle";
import ModelInfo from "../../../components/model/ModelInfo";
import {GAEventModels} from "../../../utils/SendGAEvent";
import ModelDescription from "../../../components/model/ModelDescription";
import Disclaimer from "../../../components/model/Disclaimer";
import RedditPostsModel from "./RedditPostsModel";
import TabPanel from "../../../components/model/TabPanel";

const RedditPosts = () => {
    return <ModelContainer>
        <PageTitle/>
        <div>
            <ModelTitle>Reddit Posts</ModelTitle>
            <ModelInfo model={GAEventModels.REDDIT_POSTS}/>
            <TabPanel
                modelName={GAEventModels.REDDIT_POSTS}
                modelDescription={<ModelDescription>Outputs Reddit post details as CSV file from subreddits such as: r/wallstreetbets, r/wallstreetbetsOGs, r/wallstreetbetsnew, r/stocks, r/daytrading, r/options etc...</ModelDescription>}
                content={<RedditPostsModel/>}
            />
            <Disclaimer/>
        </div>
    </ModelContainer>;
};

export default RedditPosts;


// WEBPACK FOOTER //
// ./src/routes/Dashboard/RedditPosts/index.tsx